import * as React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Container } from '../Container'
import { CtaButton } from './CtaButton'

type Props = {
  title: string
  description?: string
  steps: { title: string; description: string; image: any }[]
  buttonText?: string
}

export const ServicesHowItWorksSection: React.FC<Props> = ({ title, description, steps, buttonText }) => {
  return (
    <section className="xl:py-20 text-center">
      <Container>
        <div>
          <h2 className="title text-2xl sm:text-3xl md:text-4xl">{title}</h2>
          {description ? <p className="description">{description}</p> : null}
        </div>
        <div className="mt-6 mb-6 grid md:grid-cols-3 gap-4">
          {steps.map((value, index) => (
            <HowItWorksStep
              key={index}
              {...value}
              number={index + 1}
              stepImage={<FontAwesomeIcon size={'3x'} color={'#ea3616'} icon={value.image} />}
            />
          ))}
        </div>
        {buttonText && (
          <div className="pt-5">
            <CtaButton buttonText={buttonText} href="#" />
          </div>
        )}
      </Container>
    </section>
  )
}

const HowItWorksStep: React.FC<{
  title: string
  description: string
  stepImage: React.ReactElement
  number: number
}> = ({ title, description, stepImage, number }) => {
  return (
    <div
      className="py-4 flex bg-[#FAFAFA] flex-grow-1 flex-col h-100 text-left px-6"
      style={{ border: '1px solid #dddddd' }}
    >
      <div className="flex flex-row mb-2">
        <div className="mr-auto mt-6">{stepImage}</div>
        <div
          className="text-black opacity-10  text-[64px]"
          style={{ fontFamily: 'IndustryInc-Base', lineHeight: '64px' }}
        >
          {number}
        </div>
      </div>
      <div className="mt-3">
        <h3 className="text-xl md:text-2xl">{title}</h3>
        <p className="description">{description}</p>
      </div>
    </div>
  )
}
